import { FsLeaderboardUser, FsLeaderboardUserBase } from "./FsLeaderboardUser";

export type FsSegmentLeaderboardUser = FsLeaderboardUserBase & {
  parts: FsLeaderboardPart[] | undefined;
};

export type FsLeaderboardPart = {
  pickemId: string | undefined;
  points: { [id: string]: number } | undefined;
  driverPoints: { [driverId: string]: number } | undefined;
};

export const isFsSegmentLeaderboardUser = (
  user: FsLeaderboardUser
): user is FsSegmentLeaderboardUser => {
  return (user as FsSegmentLeaderboardUser).parts !== undefined;
};
